import {Navigate, Route, Routes} from "react-router-dom";

import {ForgotPage, LoginPage, LogoutPage, OneLoginPage, ResetPage} from "@/src/modules/auth/pages";
import {LocationDenied} from "@/src/modules/core/pages";
import {ResidentClaimPage, ResidentClaimVerifyPage} from "@/src/modules/resident-claim/pages";
import {AcknowledgeShiftPage} from "@/src/modules/shifts/pages";

const ROUTES = [
  {
    path: "logout",
    element: <LogoutPage />,
  },
  {
    path: "login",
    element: <LoginPage />,
  },
  {
    path: "onelogin",
    element: <OneLoginPage />,
  },
  {
    path: "forgot",
    element: <ForgotPage />,
  },
  {
    path: "reset",
    element: <ResetPage />,
  },
  {
    path: "acknowledge-shift",
    element: <AcknowledgeShiftPage />,
  },
  {
    path: "resident-claim",
    element: <ResidentClaimPage />,
  },
  {
    path: "resident-claim/verify/:token",
    element: <ResidentClaimVerifyPage />,
  },
  {
    path: "location-denied",
    element: <LocationDenied />,
  },
  {
    path: "*",
    element: <Navigate to="/login" />,
  },
];

export default function UnauthenticatedRoutes() {
  return (
    <Routes>
      {ROUTES.map((route) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
}
